module.exports = __webpack_public_path__ + "img/87919ed.png";